import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import UploadModal from "./UploadModal";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import theme from "../themes/lightTheme";
import Grid from "@material-ui/core/Grid";
import ConfirmDialog from "./ConfirmDialog";
import IconButton from "@material-ui/core/IconButton";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";
import EmailTemplateService from "../services/EmailTemplateService";
import notify from "../utils/notifier";
import { useTranslation } from "react-i18next";
import Util from "../utils/Util";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';


import Tooltip from "@material-ui/core/Tooltip";
import SendEmailModal from "./SendEmailModal";
//TODO: this columns to be fetched form api once api supports the same...
export const _columns = [
    { id: "templateName", label: "Name", minWidth: 100, sortable: true },
    {
        id: "organizationId",
        label: "Organization",
        minWidth: 170,
        sortable: true
    },
    { id: "applicationId", label: "Application", minWidth: 170, sortable: true },
    { id: "updatedAt", label: "Updated At", minWidth: 170,sortable: true },
    { id: "action_column", label: "Actions", minWidth: 170 }
];

//TODO: userPrefs should be fetched from user-session context
export const userPrefs = {
    rowsPerPageOptions: [10, 25, 100]
};
const useStyles = makeStyles({
    root: {
        width: "100%",
        background: "white"
    },
    tableWrapper: {
        width: "100%",
        maxHeight: "70vh",
        overflow: "auto"
    },
    visuallyHidden: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        top: 20,
        width: 1
    },
    tableHeadRight: {
        float: "right",
        display: "flex"
    },
    tableTitle: {
        float: "left",
        paddingLeft: "20px"
    },
    paper: {
        width: "45%",
        color: theme.secondaryColor,
        background: theme.primaryColor
    },
    displayFlex: {
        display: "flex"
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1
    }
});
const EDIT_MODE = "edit";
const CREATE_MODE = "create";
const SERVICE_TYPE = "email";

export default function EmailTemplate() {
    const [t, i18n] = useTranslation();
    const classes = useStyles();
    const [rows, setRows] = React.useState([]);
    const [backdrop, setBackdrop] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [queryCount, setQueryCount] = useState(0);
    const [originalRows, setOriginalRows] = React.useState([]);
    //TODO: get the columns from props
    const [columns, setColumns] = React.useState(_columns);
    const [page, setPage] = React.useState(0);
    const [originalQueryCount, setOriginalQueryCount] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(100);
    const [order, setOrder] = React.useState("asc");
    const [orderBy, setOrderBy] = React.useState("templateName");

    const [searchKey, setSearchKey] = useState({ value: "" });

    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
        let _val=searchKey.value;
        fetchData(rowsPerPage, page, property, isDesc ? "asc" : "desc", _val);
    };

    const fetchData = (pageSize = rowsPerPage, currentPage = 0, sortBy = orderBy, sortOrder = order, searchText = null) => {
        setBackdrop(true);
        let query = {
            '_page': currentPage + 1,
            '_limit': pageSize,
            '_sort': sortBy,
            '_order': sortOrder,
        }
        if (searchText) {
            query['q'] = searchText;
        }
        EmailTemplateService.getAllTemplates(query).then(
            response => {
                setBackdrop(true);
                let _data = response.data;
                _data.map(x=>{
                    x.updatedAt=new Date(x.updatedAt).toLocaleString();
                  })
                //TODO: process columns....
                setRows(_data);
                if (response.headers.hasOwnProperty('x-total-count')) {
                    setQueryCount(parseInt(response.headers['x-total-count']));
                }

                if (!searchText) {
                    setOriginalRows(_data);
                    setOriginalQueryCount(parseInt(response.headers['x-total-count']));
                }
                setBackdrop(false);
            },
            error => {
                setBackdrop(false);
                notify({
                    type: "error",
                    message: "Error occured while fetcing the data"
                });
            }
        );
    };

    React.useEffect(() => {
        //fetch all templates on load
        fetchData();
    }, []);

    const download = row => {
        EmailTemplateService.downloadTemplate(row["templateName"], row["organizationId"]).then(
            response => {
                Util.downloadTemplate(response);
            },
            error => {
                notify({
                    type: "error",
                    message: "Error: " + error.response.data.data
                });
            }
        );
    };

    const deleteRecord = row => {
        EmailTemplateService.deleteTemplate(row["templateName"], row["organizationId"]).then(
            response => {
                refreshTableDelete(row);
                notify({
                    type: "success",
                    message: "Template " + row["templateName"] + " has been deleted"
                });
            },
            error => {
                notify({
                    type: "error",
                    message: "Error: " + error.response.data.data
                });
            }
        );
    };

    const refreshTableDelete = row => {
        const newRows = [].concat(rows);
        const index = newRows.findIndex(obj => obj.templateName === row.templateName && obj.organizationId === row.organizationId);
        newRows.splice(index, 1);
        setRows(newRows);
        if(newRows.length==0){
            if(page!=0){
              //if it is not first page, when there are no rows it will get redirected to previous page
              setPage(page-1);
              fetchData(rowsPerPage, page-1, orderBy, order, searchKey.value);
            }
            else fetchData(rowsPerPage, 0, orderBy, order, searchKey.value);
          }
          else fetchData(rowsPerPage,page, orderBy, order, searchKey.value);
    };

    const refreshTableAdd = row => {
        const newRows = [].concat(rows);
        newRows.push(row.data);
        setRows(newRows);
        fetchData(rowsPerPage,page, orderBy, order, searchKey.value);
    };

    const refreshTableUpdate = row => {
        const newRows = [].concat(rows);
        let objIndex = newRows.findIndex(obj => obj.templateName === row.recordId && obj.organizationId === row.orgId);
        row.data["templateName"] = row.recordId;
        row.data["organizationId"] = row.orgId;
        row.data["metadata"] = JSON.parse(row.data["metadata"]);
        newRows[objIndex] = row.data;
        setRows(newRows);
        fetchData(rowsPerPage,page, orderBy, order, searchKey.value);
    };

    const handleDialogResponse = result => {
        if (result.status === "SUCCESS") {
            deleteRecord(result.data);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        fetchData(rowsPerPage, newPage, orderBy, order, searchKey.value);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        fetchData(+event.target.value, 0, orderBy, order, searchKey.value);
    };

    const clearSearchText = () => {
        setSearchKey({ value: "" });
        fetchData(rowsPerPage, 0, orderBy, 'desc', "");
    };

    let timeout = null;
    const handleSearch = event => {
        const _val = event.target.value;
        setSearchKey(prevState => {
            return { ...prevState, value: _val };
        });

        if (_val.length <= 2) {
            setRows(originalRows);
            setQueryCount(originalQueryCount);
            return;
        }
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            setPage(0);
            fetchData(rowsPerPage, 0, orderBy, order, _val);
        }, 200);
    };

    const handleUploadedData = result => {
        setOpen(true);
        setBackdrop(true);
        if (result.mode === "create") {
            refreshTableAdd(result);
        } else {
            refreshTableUpdate(result);
        }
        setBackdrop(false);
    };

    return (
        <Paper className={classes.root}>
            <Backdrop open={backdrop} style={{ color: "primary", zIndex: 1000000 }} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid item xs={12}>
                <div className={classes.tableTitle}>
                    <h3>{t("Email Templates")}</h3>
                </div>
                <div className={classes.tableHeadRight}>
                    <div className={classes.searchBox}>
                        <InputBase
                            onChange={handleSearch}
                            value={searchKey.value}
                            className={classes.input}
                            placeholder={t("Search Templates")}
                        />
                        {searchKey.value.length ? (
                            <IconButton
                                size="medium"
                                aria-label="search"
                                onClick={clearSearchText}
                            >
                                <CloseIcon />
                            </IconButton>
                        ) : (
                                ""
                            )}
                        <IconButton
                            size="medium"
                            aria-label="search"
                            // onClick={handleSearch}
                            disabled
                        // disabled={!searchKey.value.length}
                        >
                            <SearchIcon />
                        </IconButton>
                    </div>
                    <UploadModal
                        onUploadComplete={handleUploadedData}
                        mode={CREATE_MODE}
                        service={SERVICE_TYPE}
                    />
                </div>
                <div className={classes.tableWrapper}>
                    <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                            <TableRow>
                                {columns.map(column => (
                                    <TableCell
                                        key={column.id}
                                        align={column.numeric ? "right" : "left"}
                                        sortDirection={orderBy === column.id ? order : false}
                                    >
                                        {column.sortable ? (
                                            <TableSortLabel
                                                active={orderBy === column.id}
                                                direction={order}
                                                onClick={handleRequestSort(column.id)}
                                            >
                                                {t(column.label)}
                                                {orderBy === column.id ? (
                                                    <span className={classes.visuallyHidden}>
                                                        {order === "desc"
                                                            ? "sorted descending"
                                                            : "sorted ascending"}
                                                    </span>
                                                ) : null}
                                            </TableSortLabel>
                                        ) : (
                                                t(column.label)
                                            )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                                    {rows.map((row, index) => {
                                    const rowId = row["templateName"];
                                    return (
                                        <TableRow hover role="data-row" tabIndex={-1} key={index}>
                                            {columns.map(column => {
                                                const value = row[column.id];
                                                const isActionCell = column.id === "action_column";
                                                return (
                                                    <TableCell key={column.id} align={column.align}>
                                                        {isActionCell ? (
                                                            <div className={classes.displayFlex}>
                                                                <SendEmailModal
                                                                    rowId={rowId}
                                                                    row={Util.copyOf(row)}
                                                                />
                                                                <Tooltip title="Download" placement="top">
                                                                    <IconButton
                                                                        aria-label="download"
                                                                        color="primary"
                                                                        size="small"
                                                                        onClick={event => {
                                                                            download(Util.copyOf(row), event);
                                                                        }}
                                                                    >
                                                                        <CloudDownloadIcon fontSize="inherit" />
                                                                    </IconButton>
                                                                </Tooltip>
                                                                <UploadModal
                                                                    onUploadComplete={handleUploadedData}
                                                                    mode={EDIT_MODE}
                                                                    data={row}
                                                                    service={SERVICE_TYPE}
                                                                />
                                                                <ConfirmDialog
                                                                    dialogResultCallBack={handleDialogResponse}
                                                                    recordId={Util.copyOf(row)}
                                                                />
                                                            </div>
                                                        ) : column.format && typeof value === "number" ? (
                                                            column.format(value)
                                                        ) : (
                                                                    value
                                                                )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </div>
                <TablePagination
                    rowsPerPageOptions={userPrefs.rowsPerPageOptions}
                    component="div"
                    count={queryCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    backIconButtonProps={{
                        "aria-label": "previous page"
                    }}
                    nextIconButtonProps={{
                        "aria-label": "next page"
                    }}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                    labelRowsPerPage={t("Rows per page")}
                />
            </Grid>
        </Paper>
    );
}
